import { getUsersBySearchAction } from '@xmatters/redux/actions/listPage';

export const PIR_ACTIONS_SEARCH_USERS = 'PIR_ACTIONS_SEARCH_USERS';
export const PIR_ACTIONS_SEARCH_USERS_START = `${PIR_ACTIONS_SEARCH_USERS}_START`;
export const PIR_ACTIONS_SEARCH_USERS_SUCCESS = `${PIR_ACTIONS_SEARCH_USERS}_SUCCESS`;
export const PIR_ACTIONS_SEARCH_USERS_FAIL = `${PIR_ACTIONS_SEARCH_USERS}_FAIL`;

export const PIR_ACTIONS_ACTIVE_USERS_FILTERS =
  'PIR_ACTIONS_ACTIVE_USERS_FILTERS';
export const PIR_ACTIONS_RESET_USER_FILTERS = 'PIR_ACTIONS_RESET_USER_FILTERS';

export const PIR_ACTIONS_IS_ADD_ACTION_POPUP_OPEN =
  'PIR_ACTIONS_IS_ADD_ACTION_POPUP_OPEN';

export const getUsersBySearch = getUsersBySearchAction(
  PIR_ACTIONS_SEARCH_USERS,
);

export const setActiveUserFilters = users => ({
  type: PIR_ACTIONS_ACTIVE_USERS_FILTERS,
  payload: users,
});

export const resetUserFilters = users => ({
  type: PIR_ACTIONS_RESET_USER_FILTERS,
  payload: users,
});

export const setAddActionPopupOpen = showPopover => ({
  type: PIR_ACTIONS_IS_ADD_ACTION_POPUP_OPEN,
  payload: showPopover,
});

export const PIR_ACTIONS_OPEN_EDITOR_MODAL = 'PIR_ACTIONS_OPEN_EDITOR_MODAL';
export const openActionEditorModal = actionProps => ({
  type: PIR_ACTIONS_OPEN_EDITOR_MODAL,
  payload: actionProps,
});

export const PIR_ACTIONS_CLOSE_EDITOR_MODAL = 'PIR_ACTIONS_CLOSE_EDITOR_MODAL';
export const closeActionEditorModal = showPopover => ({
  type: PIR_ACTIONS_CLOSE_EDITOR_MODAL,
  payload: showPopover,
});
